var site = site || {};
var generic = generic || {};
var rb = rb || {};


(function ($) {
  $(document).on('perlgem.engraving.open', function (e, args) {

    if (!args.skuBaseId) {
      return;
    }
    var query = '?SKU_BASE_ID=' + args.skuBaseId;
    Drupal.behaviors.sdPerlgemEngraving.openEngraving(query);
  });

  Drupal.behaviors.sdPerlgemEngraving = {
    attach: function (context, settings) {
      var self = this;
      if (self.attached) {
        return;
      }
      self.attached = true;
    },

    openEngraving: function (query) {
      var isAerin = ($('.page-product-product-catalog-aerin').length > 0) ? 1 : 0,
      engravingClass = isAerin ? ' brand-aerin' : '';

      generic.template.get({
        path: '/templates/engraving-qvform.tmpl' + query,
        forceReload: true,
        callback: function (html) {
          generic.overlay.launch({
            content: html,
            cssClass: 'engraving-preview-popup js-engraving-preview-popup' + engravingClass,
            cssStyle: {
              width: '725px',
              height: '560px'
            },
            center: true,
            lockPosition: false,
            includeBackground: true,
            backgroundNodeClickHide: true,
            onComplete: function () {
              site.engravingInit();
              if (isAerin) {
                $('a.change-font').removeClass('engrave-style-chosen');
                $('.monogram-choice-lower').eq(0).trigger('click');
              }
            }
          });
        },
        object: []
      });
    },
    attached: false,
  };
})(jQuery);

